import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import { addError } from 'actions';
import { uploadUserOneDrive } from 'actions/assignments';
import OneDrivePicker from 'containers/OneDrivePicker/';
import DropzoneComponent from 'react-dropzone-component';
import { getToken, loginRequest, getUserId, http } from 'lib/msal';
import Modal from 'containers/Modals/Modal';
import { Button, ButtonGroup, Icon } from '@haldor/ui';
import { Image } from 'UI/Icons';
import getEnvironment from 'lib/env';

var UploadDocument = /*#__PURE__*/function (_Component) {
  _inherits(UploadDocument, _Component);

  var _super = _createSuper(UploadDocument);

  function UploadDocument(props) {
    var _this;

    _classCallCheck(this, UploadDocument);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "initState", function () {
      _this.setState({
        isModelOpen: false,
        oneDriveFiles: [],
        attachedFiles: [],
        uploadedFiles: [],
        selectedTab: 'OneDrive',
        isUploading: false,
        submitted: false,
        uploadProgress: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "modelPopUpHelper", function (popup) {
      _this.setState({
        isModelOpen: popup
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAddFileEvent", function (file) {
      var attachedFiles = _this.state.attachedFiles;

      if (file.size > 101000024) {
        _this.dropzone.removeFile(file); // File over 100MB


        swal.fire({
          title: _this.props.translate('file-too-big'),
          showCancelButton: false,
          confirmButtonText: _this.props.translate('okey')
        });
        return false;
      }

      attachedFiles.push(file);
      setTimeout(function () {
        _this.setState({
          attachedFiles: attachedFiles
        });
      }, 40);
    });

    _defineProperty(_assertThisInitialized(_this), "uploadFiles", function () {
      _this.dropzone.processQueue();
    });

    _defineProperty(_assertThisInitialized(_this), "uploadedFileEvent", function (djsFile, response) {
      _this.uploadFiles();
    });

    _defineProperty(_assertThisInitialized(_this), "dropzoneInitEvent", function (dropzone) {
      _this.dropzone = dropzone;
    });

    _defineProperty(_assertThisInitialized(_this), "triggerDropzoneEvent", function () {
      if (_this.dropzone != null) {
        _this.dropzone.hiddenFileInput.click();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onUploadError", function () {
      _this.props.addError(_this.props.translate('Forbidden'), 'error');
    });

    _defineProperty(_assertThisInitialized(_this), "onOneDrivePickerChangeEvent", function (files) {
      var parsedFiles = [];
      files.map(function (file) {
        var add = {
          id: file.id,
          key: file.name,
          value: file.url,
          markedForDeletion: false,
          fileType: 0
        };
        parsedFiles.push(add);
      });

      _this.setState({
        oneDriveFiles: parsedFiles
      });
    });

    _defineProperty(_assertThisInitialized(_this), "newDocumentButtonClickEvent", function (event) {
      var isModelOpen = _this.state.isModelOpen;
      loginRequest.scopes = getEnvironment().scopes;
      getToken(loginRequest).then(function (response) {
        _this.djsConfig.headers['Authorization'] = 'Bearer ' + response.accessToken;
      });

      _this.modelPopUpHelper(!isModelOpen);
    });

    _defineProperty(_assertThisInitialized(_this), "modelCloseClickEvent", function () {
      var _this$state = _this.state,
          submitted = _this$state.submitted,
          oneDriveFiles = _this$state.oneDriveFiles;
      var closeConfirmCondition = !submitted && (_this.dropzone && _this.dropzone.getQueuedFiles().length > 0 || oneDriveFiles.length > 0);

      if (closeConfirmCondition) {
        _this.modelPopUpHelper(false);

        _this.initState();

        _this.props.refreshDocuments();
      } else if (submitted) {
        _this.modelPopUpHelper(false);

        _this.initState();

        _this.props.refreshDocuments();
      } else {
        _this.modelPopUpHelper(false);

        _this.initState();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveFileEvent", function (file) {
      var attachedFiles = _this.state.attachedFiles;
      var fileIndex = attachedFiles.findIndex(function (f) {
        return f.upload.filename === file.upload.filename;
      });
      attachedFiles.splice(fileIndex, 1);

      _this.setState({
        attachedFiles: attachedFiles
      }, function () {
        if (_this.dropzone) {
          _this.dropzone.removeFile(file);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "UploadButtonClickEvent", function () {
      var oneDriveFiles = _this.state.oneDriveFiles;

      _this.setState({
        isUploading: true
      });

      var outerThis = _assertThisInitialized(_this);

      var uploadPromises = [];

      if (outerThis.dropzone && outerThis.dropzone.getQueuedFiles().length > 0) {
        uploadPromises.push(new Promise(function (resolve) {
          outerThis.uploadFiles();
          outerThis.dropzone.on('totaluploadprogress', function (progress) {
            outerThis.setState({
              uploadProgress: progress
            });
          });
          outerThis.dropzone.on("queuecomplete", function (files) {
            resolve(files);
          });
        }));
      }

      if (oneDriveFiles.length > 0) {
        uploadPromises.push(_this.props.uploadUserOneDrive(_this.props.assignmentId, oneDriveFiles));
      }

      Promise.all(uploadPromises).then(function (files) {
        _this.setState({
          isUploading: false,
          submitted: true
        });

        _this.modelPopUpHelper(false);

        _this.initState();

        if (_this.props.uploadError.error == true) {
          _this.props.onUploadError(_this.props.uploadError);
        } else {
          _this.props.refreshDocuments();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "tabSwitchClickEvent", function (tab) {
      _this.setState({
        selectedTab: tab
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderComputer", function () {
      var selectedTab = _this.state.selectedTab;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '1.55rem 0rem'
        },
        className: (selectedTab === 'Computer' ? '' : 'hide-content') + " upload-document clearfix gap-bottom"
      }, /*#__PURE__*/React.createElement("strong", null, _this.props.translate('computer')), /*#__PURE__*/React.createElement("div", {
        className: "dropzone-trigger icon-container",
        style: {
          height: 'auto',
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        onClick: _this.triggerDropzoneEvent,
        className: "icon"
      }, /*#__PURE__*/React.createElement(Image, null)), /*#__PURE__*/React.createElement("div", {
        className: "text",
        onClick: _this.triggerDropzoneEvent
      }, _this.props.translate('drop-files-or-click-here')), /*#__PURE__*/React.createElement(DropzoneComponent, {
        djsConfig: _this.djsConfig,
        eventHandlers: _this.dropzoneEvents,
        config: _this.componentConfig
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderOneDrive", function () {
      var selectedTab = _this.state.selectedTab;
      return /*#__PURE__*/React.createElement("div", {
        className: (selectedTab === 'OneDrive' ? '' : 'hide-content') + " clearfix gap-bottom"
      }, /*#__PURE__*/React.createElement(OneDrivePicker, {
        className: "onedrive-picker-model",
        onChange: _this.onOneDrivePickerChangeEvent
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderUploadTypes", function () {
      var selectedTab = _this.state.selectedTab;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1rem'
        }
      }, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
        style: {
          textDecoration: selectedTab === 'OneDrive' ? 'underline' : 'none'
        },
        type: "secondary",
        onClick: function onClick(e) {
          _this.tabSwitchClickEvent('OneDrive');
        }
      }, _this.props.translate('one-drive')), /*#__PURE__*/React.createElement(Button, {
        style: {
          textDecoration: selectedTab === 'Computer' ? 'underline' : 'none'
        },
        type: "secondary",
        onClick: function onClick(e) {
          _this.tabSwitchClickEvent('Computer');
        }
      }, _this.props.translate('computer'))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderDocumentList", function () {
      var _this$state2 = _this.state,
          attachedFiles = _this$state2.attachedFiles,
          oneDriveFiles = _this$state2.oneDriveFiles;
      return /*#__PURE__*/React.createElement("div", {
        className: "clearfix upload-wrapper"
      }, oneDriveFiles.length > 0 || attachedFiles.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "upload-container"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1rem'
        }
      }, oneDriveFiles.length > 0 ? /*#__PURE__*/React.createElement("strong", null, _this.props.translate('one-drive')) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: '-0.5rem',
          marginRight: '-0.5em',
          marginBottom: '1rem',
          display: 'flex'
        }
      }, oneDriveFiles.map(function (file, i) {
        var fileKey = "onedrive-include-file-".concat(i);

        if (file.fileType == null) {
          return null;
        }

        return /*#__PURE__*/React.createElement("div", {
          key: fileKey,
          className: "dropzone-file-preview"
        }, /*#__PURE__*/React.createElement("div", {
          className: "file-name"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "File"
        }), /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, file.key)));
      })), attachedFiles.length > 0 ? /*#__PURE__*/React.createElement("strong", null, _this.props.translate('computer')) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: '-0.5rem',
          marginRight: '-0.5em',
          display: 'flex'
        }
      }, attachedFiles.map(function (file, i) {
        var fileKey = "attached-file-".concat(i);
        return /*#__PURE__*/React.createElement("div", {
          key: fileKey,
          className: "dropzone-file-preview ".concat(!file.accepted ? " not-accepted" : "", " ").concat(file.upload.progress > 0 ? ' upload-started' : ' not-started')
        }, /*#__PURE__*/React.createElement("div", {
          className: "file-name"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1,
            maxWidth: 'calc(100% - 1rem)',
            wordWrap: 'break-word'
          }
        }, file.name + ' ', "(", file.size > 100000 ? Math.round(file.size / 1024 / 1024) + 'MB' : Math.round(file.size / 1024) + 'Kb', ")"), /*#__PURE__*/React.createElement("div", {
          onClick: function onClick(e) {
            _this.onRemoveFileEvent(file);
          },
          className: "file-delete-btn"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Close"
        }))), file.accepted && file.size > 7500000 ? /*#__PURE__*/React.createElement("div", {
          className: "file-warning"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Info_Blue"
        }), /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, _this.props.translate('size-warning'))) : null, !file.accepted ? /*#__PURE__*/React.createElement("div", {
          className: "file-warning"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Alert"
        }), /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, _this.props.translate('file-too-big'))) : null);
      })))) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderUploadDocumentButton", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        className: "c--button no-margin",
        onClick: function onClick(e) {
          _this.UploadButtonClickEvent();
        }
      }, _this.props.translate('upload')));
    });

    _defineProperty(_assertThisInitialized(_this), "renderModel", function () {
      var _this$state3 = _this.state,
          isModelOpen = _this$state3.isModelOpen,
          isUploading = _this$state3.isUploading;
      var translate = _this.props.translate;
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: isModelOpen,
        onClose: _this.modelCloseClickEvent,
        title: translate('Add work')
      }, isUploading ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }), /*#__PURE__*/React.createElement("br", null), _this.state.uploadProgress != null ? /*#__PURE__*/React.createElement("div", {
        className: "upload-progress"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: Math.round(_this.state.uploadProgress) + '%'
        },
        className: "upload-progress-bar"
      })) : null)) : null, /*#__PURE__*/React.createElement("div", {
        className: "document-attachment"
      }, _this.renderUploadTypes(), _this.renderOneDrive(), _this.renderComputer(), _this.renderDocumentList(), _this.renderUploadDocumentButton()));
    });

    _defineProperty(_assertThisInitialized(_this), "renderUploadButton", function () {
      var _this$props = _this.props,
          IsButtonEnable = _this$props.IsButtonEnable,
          IsTeacher = _this$props.IsTeacher;
      return /*#__PURE__*/React.createElement("div", null, IsTeacher ? null : /*#__PURE__*/React.createElement(Button, {
        disabled: !IsButtonEnable,
        type: "secondary",
        onClick: _this.newDocumentButtonClickEvent
      }, _this.props.title ? _this.props.title : _this.props.translate('upload')));
    });

    var schoolId = localStorage.getItem("hal.school".concat(getUserId()));
    _this.state = {
      isModelOpen: false,
      oneDriveFiles: [],
      attachedFiles: [],
      uploadedFiles: [],
      selectedTab: 'OneDrive',
      isUploading: false,
      submitted: false,
      uploadProgress: null
    };
    _this.dropzone = null;
    /* Configure dropzone component */

    _this.componentConfig = {
      iconFiletypes: ['.jpg', '.png', '.gif'],
      showFiletypeIcon: false,
      postUrl: http.defaults.baseURL + 'assignments/' + props.assignmentId + '/uploadDocuments?_=' + new Date().getTime(),
      dropzoneSelector: '.dropzone-trigger'
    };
    _this.djsConfig = {
      autoProcessQueue: false,
      parallelUploads: 1,
      timeout: 99900000,
      headers: {
        'SchoolId': schoolId
      }
    };
    loginRequest.scopes = getEnvironment().scopes;
    getToken(loginRequest).then(function (response) {
      _this.djsConfig.headers['Authorization'] = 'Bearer ' + response.accessToken;
    });
    _this.dropzoneEvents = {
      init: _this.dropzoneInitEvent,
      addedfile: _this.onAddFileEvent,
      success: _this.uploadedFileEvent,
      error: _this.onUploadError
    };
    return _this;
  }

  _createClass(UploadDocument, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'left'
        }
      }, this.renderUploadButton(), this.renderModel());
    }
  }]);

  return UploadDocument;
}(Component);

_defineProperty(UploadDocument, "defaultProps", {
  IsButtonEnable: true
});

function mapStateToProps(state) {
  return {
    uploadError: state.assignments.uploadError,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  uploadUserOneDrive: uploadUserOneDrive,
  addError: addError
})(UploadDocument);